import React, { useContext, useReducer } from 'react';
import { ALERT_TYPES } from '../constants';

export const AppContext = React.createContext();

export const ADD = 'ADD';
export const REMOVE = 'REMOVE';
export const REMOVE_ALL = 'REMOVE_ALL';

const alertInitialState = [];

export const alertReducer = (state, action) => {
  switch (action.type) {
    case ADD:
      return [
        {
          id: Date.now(),
          content: action.payload.content,
          type: action.payload.type,
        },
      ];
    case REMOVE:
      return state.filter((a) => a.id !== action.payload.id);
    case REMOVE_ALL:
      return alertInitialState;
    default:
      return state;
  }
};

export default function AppContextProvider({ children }) {
  const [alerts, alertDispatch] = useReducer(alertReducer, alertInitialState);

  const state = {
    alerts,
    alertDispatch,
  };

  return <AppContext.Provider value={{ ...state }}>{children}</AppContext.Provider>;
}

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error(
      'useAppContext cannot be rendered outside the AppContext.Provider component'
    );
  }
  return {
    alerts: context.alerts,
    addSuccessAlert: (content) =>
      context.alertDispatch({
        type: ADD,
        payload: {
          content: content,
          type: ALERT_TYPES.SUCCESS,
        },
      }),
    addInfoAlert: (content) =>
      context.alertDispatch({
        type: ADD,
        payload: {
          content: content,
          type: ALERT_TYPES.INFO,
        },
      }),
    addErrorAlert: (content) =>
      context.alertDispatch({
        type: ADD,
        payload: {
          content: content,
          type: ALERT_TYPES.ERROR,
        },
      }),
    removeAlert: (id) =>
      context.alertDispatch({
        type: REMOVE,
        payload: {
          id,
        },
      }),

    clearAlerts: () =>
      context.alertDispatch({
        type: REMOVE_ALL,
      }),
  };
};
